import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';
import { Observable } from 'rxjs';

import { I18nTranslator } from '../../../../i18n/translate';
import { AROrgeOrder, AROrgeOrderItem } from '../../../../models/agrorendement-orge.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { AROrgeService } from '../../../../services/agrorendement-orge.service';
import { ParcelService } from '../../../../services/parcel.service';
import { PreventDoubleClickDirective } from '../../../../utils/preventDoubleClick';
import { AROrderEditComponent } from '../common/order-edit.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-orge-order-edit',
  templateUrl: '../common/order-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, PreventDoubleClickDirective, CampaignYearPipe, CapitalizePipe, HectareConverterPipe, TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
  providers: [AROrgeService, ParcelService],
})
export class AROrgeOrderEditComponent
  extends AROrderEditComponent<AROrgeOrder, AROrgeOrderItem>
  implements OnInit, OnDestroy
{
  @Input() orderItem: AROrgeOrderItem;

  constructor(
    protected service: AROrgeService,
    protected parcelService: ParcelService,
    protected i18nTranslator: I18nTranslator,
    protected modal: ModalService,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.orge.section');
    this.specyUrlPart = ['azote', 'orge'];
    this.specyIconClass = 'fa-bullseye';
    this.specyOrderCode = 'ORDO';
    this.routeActionIndex = 4;
    this.toolStatusCode = 'AROrge';
  }

  buildNew(): AROrgeOrder {
    return new AROrgeOrder();
  }

  remoteGetOrderItems(orderItemIds: Array<number>): Observable<AROrgeOrderItem[]> {
    return this.service.getOrderItems(orderItemIds, null, false);
  }

  remoteGetOrderItem(orderItemId: number): Observable<AROrgeOrderItem> {
    return this.service.getOrderItem(orderItemId);
  }
}
